import { default as TeamList } from './TeamList';

export default TeamList;
